import { Skeleton } from "@mui/material";

const Loading = () => {
  return (
    <Skeleton
      variant="rectangular"
      height={200}
      sx={{ mb: 2, borderRadius: 2 }}
    />
  );
};

export default Loading;
